import { render, staticRenderFns } from "./back-arrow.vue?vue&type=template&id=1c245274&scoped=true"
var script = {}
import style0 from "./back-arrow.vue?vue&type=style&index=0&id=1c245274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c245274",
  null
  
)

export default component.exports